import React from "react";
import { Modal } from "react-bootstrap";
import FormikForm from "components/shared/FormikForm";

export default function WalletBalancePop({
  show,
  handleClose,
  title,
  loading,
  initialValues,
  inputFields,
  handleConfirm,
  Validation,
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormikForm
          initialValues={initialValues}
          validationSchema={Validation}
          onSubmit={handleConfirm}
          loading={loading}
          inputFields={inputFields}
          buttonText={"Submit"}
          col={6}
        />
      </Modal.Body>
    </Modal>
  );
}
